import { render, staticRenderFns } from "./DeveloperLeadView.vue?vue&type=template&id=1380ab4e"
import script from "./DeveloperLeadView.vue?vue&type=script&lang=js"
export * from "./DeveloperLeadView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports